import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { LoginService } from '../login.service';

// Datamining AI helper is off unless the server sets config.features.dataminingAI
export const datamineGuard: CanActivateFn = () => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  if (!loginService.username) {
    return router.createUrlTree(['/']);
  }

  return loginService.premissionsReady.pipe(
    take(1),
    map((premissions) => (premissions?.DataminingAI ? true : router.createUrlTree(['/patsearch'])))
  );
};
